var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { action, autorun, flow, observable } from "mobx";
import { StoreBase } from "./StoreBase";
import { computedFn } from "mobx-utils";
let GraphqlStoreBase = /** @class */ (() => {
    class GraphqlStoreBase extends StoreBase {
        constructor(name, authStore, apolloClient, queryDocument, queryResultDataExtractor, queryResultDataItemPatcher) {
            super(name);
            this.data = observable.array([]);
            this.fetchData = flow(function* (isUpdate) {
                this.setState(isUpdate ? "updating" : "fetching");
                try {
                    // TypeScript clowning around for MobX/flow requiring yield vs. await
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    const yieldedQueryResult = yield this.apolloClient.query({
                        query: this.queryDocument,
                        fetchPolicy: isUpdate ? "network-only" : "cache-first",
                    });
                    const queryResult = yieldedQueryResult;
                    if (queryResult.errors) {
                        throw new Error(JSON.stringify(queryResult.errors)); // stringify errors
                    }
                    if (!queryResult.data) {
                        throw new Error("No data returned");
                    }
                    const data = this.queryResultDataExtractor(queryResult.data);
                    if (!this.queryResultDataItemPatcher) {
                        this.data.replace(data);
                    }
                    else {
                        this.data.replace(data.map(this.queryResultDataItemPatcher));
                    }
                    this.setState("ready");
                }
                catch (error) {
                    this.setError(JSON.stringify(error)); // stringify exception
                }
            });
            this.findById = computedFn(function (id) {
                // For now we're going to assume that our datasets are small enough
                // that a linear search is good enough.
                return this.data.find(item => item.id === id);
            });
            this.apolloClient = apolloClient;
            this.queryDocument = queryDocument;
            this.queryResultDataExtractor = queryResultDataExtractor;
            this.queryResultDataItemPatcher = queryResultDataItemPatcher;
            autorun(() => {
                if (authStore.isUserAuthenticated) {
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    this.fetchData(false);
                }
                else {
                    this.clear();
                }
            });
        }
        update() {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.fetchData(true);
            });
        }
        clear() {
            this.data.clear();
        }
    }
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], GraphqlStoreBase.prototype, "clear", null);
    return GraphqlStoreBase;
})();
export { GraphqlStoreBase };
//# sourceMappingURL=GraphqlStoreBase.js.map